import script from "./CreateSupportRequestModal.vue?vue&type=script&setup=true&lang=js"
export * from "./CreateSupportRequestModal.vue?vue&type=script&setup=true&lang=js"

import "./CreateSupportRequestModal.vue?vue&type=style&index=0&id=0ef5f7ce&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0ef5f7ce"]])

export default __exports__